import { IconButton, Tooltip } from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";
import VideocamIcon from "@mui/icons-material/Videocam";
import useLanguage from "../../hooks/useLanguage";

const EditMediaToolbarButtons = ({ onRequestImageEdit, onRequestVideoEdit }) => {
  const [{ components: { mediaEditor } }] = useLanguage();
  const strings = mediaEditor.toolbar;

  const handleImageClick = () => {
    // MVP: window.prompt is acceptable per spec
    const url = window.prompt(strings.imageUrlPrompt, "");
    if (url && url.trim()) {
      onRequestImageEdit(url.trim());
    }
  };

  const handleVideoClick = () => {
    const url = window.prompt(strings.videoUrlPrompt, "");
    if (url && url.trim()) {
      onRequestVideoEdit(url.trim());
    }
  };

  return (
    <>
      <Tooltip title={strings.editImage}>
        <IconButton
          size="small"
          onClick={handleImageClick}
          aria-label={strings.editImage}
        >
          <ImageIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title={strings.editVideo}>
        <IconButton
          size="small"
          onClick={handleVideoClick}
          aria-label={strings.editVideo}
        >
          <VideocamIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default EditMediaToolbarButtons;
